import { Field } from '@atlaskit/form';
import { CheckboxSelect, OptionsType } from '@atlaskit/select';
import React from 'react';
import { LineItemSelect } from '@atlassian/cssxp-types-billing';
import { getErrorMessage, getValidationState, validate } from './select-multiple-lineItem-form';

interface Props {
  options: OptionsType<LineItemSelect>;
  fieldName?: string;
  fieldLabel?: string;
  placeholder?: string;
  errorMessage?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  setSelectedLineItem?: (value: any) => void;
}

export const MultiCheckboxSelectLineItemFormField = ({
  options,
  fieldName = 'lineItems',
  fieldLabel = 'Invoice line items',
  placeholder = 'Select line items',
  errorMessage = 'Please select line items',
  isRequired = false,
  isDisabled = false,
  setSelectedLineItem,
}: Props) => {
  if (!options) {
    return null;
  }

  return (
    <>
      <Field name={fieldName} label={fieldLabel} isRequired={isRequired} validate={validate} isDisabled={isDisabled}>
        {({ fieldProps, error }) => (
          <div data-testid="multiple-lineitems-checkbox-field">
            <CheckboxSelect
              {...fieldProps}
              classNamePrefix="multiple-lineitems-field"
              id={fieldProps.id}
              options={options}
              onChange={(value) => {
                fieldProps.onChange(value);
                setSelectedLineItem?.(value);
              }}
              placeholder={placeholder}
              validationState={getValidationState(error)}
            />
            {getErrorMessage(error, errorMessage)}
          </div>
        )}
      </Field>
    </>
  );
};
